// Toast queue store — pushed from anywhere, rendered in <Toasts />.

import { create } from "zustand";

export type ToastKind = "success" | "error" | "warn" | "info";

export type Toast = {
  id: string;
  kind: ToastKind;
  title: string;
  desc?: string;
};

type Store = {
  items: Toast[];
  push: (t: Omit<Toast, "id">) => void;
  remove: (id: string) => void;
};

export const useToasts = create<Store>((set) => ({
  items: [],
  push: (t) => {
    const id = crypto.randomUUID();
    set((s) => ({ items: [...s.items, { ...t, id }] }));
    setTimeout(() => {
      set((s) => ({ items: s.items.filter((x) => x.id !== id) }));
    }, 4000);
  },
  remove: (id) => set((s) => ({ items: s.items.filter((x) => x.id !== id) })),
}));

export const toast = {
  success: (title: string, desc?: string) => useToasts.getState().push({ kind: "success", title, desc }),
  error:   (title: string, desc?: string) => useToasts.getState().push({ kind: "error", title, desc }),
  warn:    (title: string, desc?: string) => useToasts.getState().push({ kind: "warn", title, desc }),
  info:    (title: string, desc?: string) => useToasts.getState().push({ kind: "info", title, desc }),
};
